<template>
    <component :is="componentType" :class="[$style['mds-td'], classObject]">
        <slot />
    </component>
</template>
<script>
    export default {
        name: 'MdsTd',
        props: {
            rightAligned: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, it right aligns the cell text.',
                },
            },
            rowHeader: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, makes the cell tagname a `th`.',
                },
            },
        },
        computed: {
            componentType() {
                return this.rowHeader ? 'th' : 'td';
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-td--right']] = this.rightAligned;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @use './td.scss';
</style>
